import { DeleteIcon, LockIcon } from 'modules/sprites';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { RemoveWatcherButton, StyledWatcherItem, WatcherAvatar, WatcherName } from './WatcherItem.styles';
import { WatcherItemProps } from './WatcherItem.types';

const qa = bemFactory.qa('reql-edit-watchers-popup-item');

const WatcherItem: FC<WatcherItemProps> = memo((props) => {
    const { watcherId, readonly, expandedUser, onRemoveWatcher } = props;

    return (
        <StyledWatcherItem readOnly={readonly} data-qa={qa()} data-qa-id={watcherId}>
            <WatcherAvatar title={null} size={30} user={expandedUser} />

            <WatcherName>{expandedUser.displayName}</WatcherName>

            {readonly ? (
                <LockIcon width={8} height={10} />
            ) : (
                <RemoveWatcherButton execute={() => onRemoveWatcher(watcherId)} qa={qa('button')}>
                    <DeleteIcon width={8} height={8} />
                </RemoveWatcherButton>
            )}
        </StyledWatcherItem>
    );
});

export default WatcherItem;
